import * as React from 'react';
import * as I18n from 'i18n-js';
import RecentArticles from './recent_articles';
import HomepageCategories from '../homepage_categories';
import HomepageCuratedSetRow from '../homepage_curated_set_row';
import HomepageSell from './homepage_sell';
import HomepageNewsletter from './homepage_newsletter';
import HomepageValueProps from './homepage_value_props';

import RecentlyViewedListings from '@reverbdotcom/commons/dist/cms/components/recently_viewed_listings';
import CmsListingsCollection from '@reverbdotcom/commons/dist/cms/components/cms_listings_collection';
import CmsEmbed from '@reverbdotcom/commons/dist/components/cms_embed';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';
import { isExperimentEnabled } from '@reverbdotcom/commons/dist/user_context_helpers';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_types';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/dist/elog/mparticle';
import { useViewTracking } from '@reverbdotcom/commons/dist/use_tracking';

import { US_CON_CODE } from '../../shared/constants';
import experiments from '@reverbdotcom/commons/dist/experiments';
import PopularProducts from './popular_products';

export function LoggedOutHomepage() {
  const user = useUser();
  const showPopularProducts = isExperimentEnabled(user, experiments.LOGGED_OUT_POPULAR_PRODUCTS);
  const mParticleViewData = {
    componentName: 'LoggedOutHomepage',
    eventName: MParticleEventName.ComponentView,
    experiments: formatExperimentsForEventAttributes(user, [
      experiments.LOGGED_OUT_POPULAR_PRODUCTS,
    ]),
  };

  useViewTracking(mParticleViewData, true);

  return (
    <div className="homepage bg-white pt-half">
      <HomepageValueProps />
      <div className="homepage-container__component-wrapper">
        <RecentlyViewedListings
          title={I18n.t('discovery.recentlyViewed.title')}
          largeTiles
        />
      </div>
      {
        showPopularProducts && <PopularProducts />
      }
      <div className="homepage-container__component-wrapper">
        <CmsEmbed slug="homepage-embed" ssrMode="static-only" />
      </div>
      <h2 className="homepage__subheading">
        {I18n.t('discovery.homepage.loggedOutNew.shopByInstrument')}
      </h2>
      <div className="homepage-container__component-wrapper homepage-container__component-wrapper--thin">
        <HomepageCategories noTitle />
      </div>
      <div className="homepage-container__component-wrapper">
        <h2 className="homepage__subheading">
          {I18n.t('discovery.homepage.loggedOutNew.explore')}
        </h2>
        <RecentArticles title=" " />
      </div>
      {user.shippingRegionCode === US_CON_CODE &&
        <div className="homepage-container__component-wrapper">
          <h2 className="homepage__subheading">
            {I18n.t('discovery.homepage.loggedOutNew.collections')}
          </h2>
          <HomepageCuratedSetRow noTitle />
        </div>
      }
      <div className="scaling-mb-7 scaling-mt-10">
        <HomepageNewsletter signupReason="loggedouthomepage" />
      </div>
      <div className="homepage-container__component-wrapper">
        <h2 className="homepage__subheading">
          {I18n.t('discovery.homepage.loggedOutNew.latestGear')}
        </h2>
        <CmsListingsCollection
          ctaTargetHref="/marketplace?condition=used"
          conditionSlugs={['used']}
          userShippingRegion={user.shippingRegionCode}
          componentName="HomepageLatestListings"
          maxCount={12}
          largeTiles
          ssr={false}
        />
      </div>
      <div className="homepage-container__component-wrapper">
        <h2 className="homepage__subheading">
          {I18n.t('discovery.homepage.loggedOutNew.dealsAndSteals')}
        </h2>
        <CmsListingsCollection
          curatedSetId="8"
          componentName="HomepageDealsAndSteals"
          ctaTargetHref="/promo/deals-and-steals"
          maxCount={12}
          largeTiles
          ssr={false}
        />
      </div>
      <div className="scaling-mt-10 pb-5 mobile-pb-0">
        <HomepageSell />
      </div>
    </div>
  );
}

export default LoggedOutHomepage;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/logged_out.tsx